import { DEPTH_EPSILON } from '../measure/promotion';
import { DEPTH_TOLERANCE } from './constants';

/** True when two depths lie within DEPTH_TOLERANCE of each other (CONTEXT.md, Campaign run). */
export function withinDepthTolerance(a: number, b: number): boolean {
  return Math.abs(a - b) <= DEPTH_TOLERANCE + DEPTH_EPSILON;
}

/** True when `price` reaches `floor`, a price derived from a depth, allowing the floating-point slack of a depth comparison. */
export function priceReachesFloor(price: number, floor: number): boolean {
  return price >= floor * (1 - DEPTH_EPSILON);
}
